/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RoleListResponse } from '../../models/role-list-response';

export interface GetRoles$Params {

/**
 * filter roles by branch_access
 */
  branch_access?: 'ALL' | 'BRANCH_COLLECTION' | 'BRANCH_SINGLE';
}

export function getRoles(http: HttpClient, rootUrl: string, params?: GetRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<RoleListResponse>> {
  const rb = new RequestBuilder(rootUrl, getRoles.PATH, 'get');
  if (params) {
    rb.query('branch_access', params.branch_access, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RoleListResponse>;
    })
  );
}

getRoles.PATH = '/api/v1/roles';
